"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { trackNavigation } from "@/lib/analytics";

export function NavigationTracker() {
  const pathname = usePathname();
  const previousPathname = useRef<string | null>(null);

  useEffect(() => {
    if (previousPathname.current !== null && previousPathname.current !== pathname) {
      trackNavigation(pathname, previousPathname.current);
    }
    previousPathname.current = pathname;
  }, [pathname]);

  return null;
}
